export const PLATFORM_LOGIN_URL = '/app/developer';
export const PLATFORM_PATH_RE = /^\/platform.+/;

export const CAPTCHA_CLIENT_SITE_KEY =
  '6LdY6DkUAAAAADQgB2MNeHGblu1EzzSjGm437aPQ';
export const CAPTCHA_CLIENT_REF = 'recaptcha';
export const CAPTCHA_REQUIRED_FIELD_ERROR = 'captcha_required';
export const EVENT_CAPTCHA_RENDERED = 'signup: captcha rendered';
export const EVENT_CAPTCHA_VERIFICATION_FAIL =
  'signup: captcha verification failed';
